import React from 'react';
import Loader from '../UI/Loader/Loader';
import { Formik, Form } from 'formik';
import PrimaryModal from '../UI/Modal/PrimaryModal';
import { PrimaryButton } from "../UI";
import Dropdown from '../UI/Dropdown/Dropdown';
import { createAtAudienceFromTealiumTaskSchema } from '../../schemas';
import { useContentfulContext } from '../../contexts/ContentfulContext';

const UpdateContentfulModal = ({ closeModal, loading, handleSubmit, error, experience }) => {
    const offers = experience?.associated_contentful_offer_id || []
    const { content } = useContentfulContext();
    const dropdownItems = offers.map(offer => ({
        name: offer,
        val: offer
    }));
    const multiSelect = true;

    return (
        <PrimaryModal title="Update Contentful Entry" hideModal={() => closeModal(false)}>
            <div className='p-6 space-y-6'>
                {loading && <Loader />}
                <Formik
                    initialValues={{
                        selected_entry: []
                    }}
                    onSubmit={(values) => {
                        const selectedOffer = multiSelect ? values.selected_entry : values.selected_entry[0];
                        handleSubmit(selectedOffer);
                    }}
                >
                    {({ errors, touched, values, setFieldValue, setTouched }) => (
                        <Form className="space-y-4 md:space-y-6" action="#" id="update-offer-form">
                            <div className="mb-4">
                                <label htmlFor="selected_entry" className="block text-gray-700 text-sm font-bold mb-2">
                                    Select Entry to Update
                                </label>
                                <Dropdown
                                    items={dropdownItems}
                                    width="200"
                                    callback={(selected) => {
                                        setFieldValue('selected_entry', Array.isArray(selected) ? selected : [selected]);
                                        setTouched({ ...touched, selected_entry: true });
                                    }}
                                    initialValue={
                                        values.selected_entry.length
                                            ? values.selected_entry.map(val => ({ name: val, val }))
                                            : null
                                    }
                                    noItemSelectedTitle={multiSelect ? "Select Offers" : "Select Offer"}
                                    searchable={false}
                                    multiSelect={multiSelect || createAtAudienceFromTealiumTaskSchema}
                                />
                                {errors.selected_entry && touched.selected_entry ? (
                                    <p className="mt-2 text-sm text-red-500">{errors.selected_entry}</p>
                                ) : null}
                            </div>
                            {error && <p className="text-base leading-tight tracking-tight text-red-500 mb-4">{error}</p>}
                            <div className="flex items-center justify-end space-x-2">
                                <PrimaryButton type="submit">{content.UPDATE_OFFERS_MODAL.submit}</PrimaryButton>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </PrimaryModal>
    );
};

export default UpdateContentfulModal;